export const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const passwordRegexp = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/g
